import { Box, Button } from '@mui/material'
import { ReactComponent as CameraLogo } from 'assets/camera_group_logo.svg'
import { ReactComponent as ArrowNext } from 'assets/fill_back_arrow.svg'
import { ReactComponent as MenuIconCattles } from 'assets/icons/menu_cattles.svg'
import CustomTooltip from 'components/shared/CustomTooltip'
import { useGetCameraList } from 'hook/query/useGetCameraList'
import { CameraType } from 'models/IFrameInfo'
import { useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import { COLORS } from 'styles/colors'
import { CardStandart } from 'ui/CardStandart'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'
import DigitizatedModal from '../shared/digitization-modal/DigitizationModal'

const tooltipContent =
	'Доступное количество голов для оцифровки согласно вашей лицензии.'

interface DigitizationWidjet {
	isExpiredLicense: boolean
	digitizated: {
		value: number
		out_of: number
		unidentified: number
	}
	loadingStatistics: boolean
}

const DigitizationWidjet = props => {
	const { digitizated, isExpiredLicense, loadingStatistics } = props
	const [openModal, setOpenModal] = useState<boolean>(false)
	const { data: cameraList, isLoading: fetchCameraList } = useGetCameraList({
		type: CameraType.Identification,
	})
	const onClickDigitBtn = () => {
		setOpenModal(true)
	}
	return (
		<CardStandart sx={{ padding: '24px' }}>
			<Box
				display={'flex'}
				flexDirection={'row'}
				alignItems={'center'}
				justifyContent={'space-between'}
			>
				<Box>
					<Box
						display={'flex'}
						flexDirection={'row'}
						alignItems={'center'}
						gap={'4px'}
					>
						<MenuIconCattles fill={COLORS.secondary} />
						{loadingStatistics ? (
							<Skeleton width={200} height={34} />
						) : isExpiredLicense ? (
							<TypographySecondary14>Истёк срок лицензии</TypographySecondary14>
						) : (
							<Box
								display={'flex'}
								flexDirection={'column'}
								alignItems={'left'}
								gap={'4px'}
							>
								<Box
									display={'flex'}
									flexDirection={'row'}
									alignItems={'center'}
									gap={'4px'}
								>
									<TypographyPrimary16Bold>
										Оцифровано {digitizated.value}
									</TypographyPrimary16Bold>
									<TypographySecondary>
										{'/' + digitizated.out_of}
									</TypographySecondary>
									<CustomTooltip
										placement={'top'}
										width={'18px'}
										height={'18px'}
										info={true}
										title={tooltipContent}
									/>
								</Box>
								{/* <TypographySecondary>
									Не опознано{' '}
									{digitizated?.unidentified && digitizated.unidentified}
								</TypographySecondary> */}
							</Box>
						)}
					</Box>
				</Box>
				{fetchCameraList || loadingStatistics ? (
					<Skeleton width={200} height={34} />
				) : (
					<Button
						onClick={onClickDigitBtn}
						disableRipple={true}
						disabled={isExpiredLicense}
						sx={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							gap: '6px',
							textTransform: 'none',
							'&:hover': {
								backgroundColor: 'transparent',
							},
						}}
					>
						<CameraLogo stroke={isExpiredLicense ? COLORS.icon : COLORS.main} />
						<TypographyPrimary16Bold
							sx={{ color: isExpiredLicense ? COLORS.icon : COLORS.main }}
						>
							Оцифровать
						</TypographyPrimary16Bold>
						<ArrowNext
							style={{ transform: 'rotate(180deg)' }}
							stroke={isExpiredLicense ? COLORS.icon : COLORS.main}
						/>
					</Button>
				)}
			</Box>
			<DigitizatedModal
				cameraList={cameraList}
				open={openModal}
				onCloseModal={() => setOpenModal(false)}
			/>
		</CardStandart>
	)
}

export default DigitizationWidjet
